import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import {
  GLOBAL_STATE,
  GROUP_ALL,
  GROUP_ALL_SHORT,
  GROUP_ALL_UPDATED,
  GROUP_ASSIGN,
  GROUP_ASSIGNED_LIST,
  GROUP_DELETE,
  GROUP_EDIT,
  GROUP_LIST,
  GROUP_SHUFFLE,
  GROUP_STUDENT_TRANSFER,
} from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const GROUPING = GLOBAL_STATE

const groupSlice = createSlice({
  name: GROUPING,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.groupAll.pending, state => {
        state[GROUP_ALL].loading = true
      })
      .addCase(actionCreators.groupAll.rejected, (state, action) => {
        state[GROUP_ALL].loading = false
        state[GROUP_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.groupAll.fulfilled, (state, action) => {
        state[GROUP_ALL].loading = false
        state[GROUP_ALL].error = null
        state[GROUP_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.groupAllUpdated.pending, state => {
        state[GROUP_ALL_UPDATED].loading = true
      })
      .addCase(actionCreators.groupAllUpdated.rejected, (state, action) => {
        state[GROUP_ALL_UPDATED].loading = false
        state[GROUP_ALL_UPDATED].error = action.payload as AxiosError
      })
      .addCase(actionCreators.groupAllUpdated.fulfilled, (state, action) => {
        state[GROUP_ALL_UPDATED].loading = false
        state[GROUP_ALL_UPDATED].error = null
        state[GROUP_ALL_UPDATED].data = action.payload
      })

    builder
      .addCase(actionCreators.groupAllShort.pending, state => {
        state[GROUP_ALL_SHORT].loading = true
      })
      .addCase(actionCreators.groupAllShort.rejected, (state, action) => {
        state[GROUP_ALL_SHORT].loading = false
        state[GROUP_ALL_SHORT].error = action.payload as AxiosError
      })
      .addCase(actionCreators.groupAllShort.fulfilled, (state, action) => {
        state[GROUP_ALL_SHORT].loading = false
        state[GROUP_ALL_SHORT].error = null
        state[GROUP_ALL_SHORT].data = action.payload
      })

    //builder
    //  .addCase(actionCreators.groupAllForAssessment.pending, state => {
    //    state[GROUP_ALL_FOR_ASSESSMENT].loading = true
    //  })
    //  .addCase(actionCreators.groupAllForAssessment.rejected, (state, action) => {
    //    state[GROUP_ALL_FOR_ASSESSMENT].loading = false
    //    state[GROUP_ALL_FOR_ASSESSMENT].error = action.payload as AxiosError
    //  })
    //  .addCase(actionCreators.groupAllForAssessment.fulfilled, (state, action) => {
    //    state[GROUP_ALL_FOR_ASSESSMENT].loading = false
    //    state[GROUP_ALL_FOR_ASSESSMENT].error = null
    //    state[GROUP_ALL_FOR_ASSESSMENT].data = action.payload
    //  })

    builder
      .addCase(actionCreators.groupList.pending, state => {
        state[GROUP_LIST].loading = true
      })
      .addCase(actionCreators.groupList.rejected, (state, action) => {
        state[GROUP_LIST].loading = false
        state[GROUP_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.groupList.fulfilled, (state, action) => {
        state[GROUP_LIST].loading = false
        state[GROUP_LIST].error = null
        state[GROUP_LIST].data = action.payload
      })

    builder
      .addCase(actionCreators.groupAssign.pending, state => {
        state[GROUP_ASSIGN].loading = true
      })
      .addCase(actionCreators.groupAssign.rejected, (state, action) => {
        state[GROUP_ASSIGN].loading = false
        state[GROUP_ASSIGN].error = action.payload as AxiosError
      })
      .addCase(actionCreators.groupAssign.fulfilled, (state, action) => {
        state[GROUP_ASSIGN].loading = false
        state[GROUP_ASSIGN].error = null
        state[GROUP_ASSIGN].data = action.payload
      })

    builder
      .addCase(actionCreators.groupAssignedList.pending, state => {
        state[GROUP_ASSIGNED_LIST].loading = true
      })
      .addCase(actionCreators.groupAssignedList.rejected, (state, action) => {
        state[GROUP_ASSIGNED_LIST].loading = false
        state[GROUP_ASSIGNED_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.groupAssignedList.fulfilled, (state, action) => {
        state[GROUP_ASSIGNED_LIST].loading = false
        state[GROUP_ASSIGNED_LIST].error = null
        state[GROUP_ASSIGNED_LIST].data = action.payload
      })

    builder
      .addCase(actionCreators.groupEdit.pending, state => {
        state[GROUP_EDIT].loading = true
      })
      .addCase(actionCreators.groupEdit.rejected, (state, action) => {
        state[GROUP_EDIT].loading = false
        state[GROUP_EDIT].error = action.payload as AxiosError
      })
      .addCase(actionCreators.groupEdit.fulfilled, (state, action) => {
        state[GROUP_EDIT].loading = false
        state[GROUP_EDIT].error = null
        state[GROUP_EDIT].data = action.payload
      })

    builder
      .addCase(actionCreators.groupDelete.pending, state => {
        state[GROUP_DELETE].loading = true
      })
      .addCase(actionCreators.groupDelete.rejected, (state, action) => {
        state[GROUP_DELETE].loading = false
        state[GROUP_DELETE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.groupDelete.fulfilled, (state, action) => {
        state[GROUP_DELETE].loading = false
        state[GROUP_DELETE].error = null
        state[GROUP_DELETE].data = action.payload
      })

    builder
      .addCase(actionCreators.groupShuffle.pending, state => {
        state[GROUP_SHUFFLE].loading = true
      })
      .addCase(actionCreators.groupShuffle.rejected, (state, action) => {
        state[GROUP_SHUFFLE].loading = false
        state[GROUP_SHUFFLE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.groupShuffle.fulfilled, (state, action) => {
        state[GROUP_SHUFFLE].loading = false
        state[GROUP_SHUFFLE].error = null
        state[GROUP_SHUFFLE].data = action.payload
      })

    builder
      .addCase(actionCreators.groupStudentTransfer.pending, state => {
        state[GROUP_STUDENT_TRANSFER].loading = true
      })
      .addCase(actionCreators.groupStudentTransfer.rejected, (state, action) => {
        state[GROUP_STUDENT_TRANSFER].loading = false
        state[GROUP_STUDENT_TRANSFER].error = action.payload as AxiosError
      })
      .addCase(actionCreators.groupStudentTransfer.fulfilled, (state, action) => {
        state[GROUP_STUDENT_TRANSFER].loading = false
        state[GROUP_STUDENT_TRANSFER].error = null
        state[GROUP_STUDENT_TRANSFER].data = action.payload
      })

    builder.addCase(actionCreators.groupListClear, state => {
      state[GROUP_LIST] = defaultState()
    })

    builder.addCase(actionCreators.groupAllClear, state => {
      state[GROUP_ALL] = defaultState()
    })

    builder.addCase(actionCreators.groupAllUpdatedClear, state => {
      state[GROUP_ALL_UPDATED] = defaultState()
    })

    builder.addCase(actionCreators.groupAllShortClear, state => {
      state[GROUP_ALL_SHORT] = defaultState()
    })

    //builder.addCase(actionCreators.groupAllForAssessmentClear, state => {
    //  state[GROUP_ALL_FOR_ASSESSMENT] = defaultState()
    //})

    builder.addCase(actionCreators.groupAssignClear, state => {
      state[GROUP_ASSIGN].loading = true
    })

    builder.addCase(actionCreators.groupAssignedListClear, state => {
      state[GROUP_ASSIGNED_LIST].loading = true
    })

    builder.addCase(actionCreators.groupShuffleClear, state => {
      state[GROUP_SHUFFLE].loading = true
    })

    builder.addCase(actionCreators.groupStudentTransferClear, state => {
      state[GROUP_STUDENT_TRANSFER].loading = true
    })
  },
})

export const { reducer: groupReducer } = groupSlice
